import type { ReportSectionKey } from '../contexts/ReportSettingsContext';

export const optionalReportSections: {
  key: ReportSectionKey;
  name: string;
  description: string;
}[] = [{
  key: 'signups',
  name: 'Sign-ups',
  description: 'New members by where they signed up'
}, {
  key: 'revenue',
  name: 'Revenue',
  description: 'Sign-up and renewal revenue'
}, {
  key: 'forecast',
  name: 'Next 12 months',
  description: 'Forecast revenue and orders'
}, {
  key: 'health',
  name: 'Club health',
  description: 'Growth rate and averages'
}, {
  key: 'clubs',
  name: 'Members by club',
  description: 'Members by club, pack size and frequency'
}];

export const reportSendTimes = ['5:00 AM', '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM'];
